import gql from 'graphql-tag';

export default gql(`
	query settings {
		settings {
			name
			updated_at
            value
		}
	}
`);

